<template>
  <div class="sn-f-col-b-c recharge">
    <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
      <div class="sn-f-s-c region">
        <div class="sn-f-s-c patient-title">
          <div class="required">*</div>
          <div>就诊人：</div>
        </div>
        <div v-if="!$sn.validate.array(patientList)" @click="handlePatientInfo();">
          暂未获取到就诊人，<span class="sn-pointer sn-fc-main">点击刷新</span>
        </div>
        <div v-else-if="patientList.length === 0" @click="navigateUrl('addition-patient');">
          暂无就诊人，<span class="sn-pointer sn-fc-main">点击添加</span>
        </div>
        <template v-else>
          <el-select :value="selectedPatient.patientId" @change="sendBackPatient">
            <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientList"></el-option>
          </el-select>
        </template>
      </div>
      <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
        <div class="sn-f-s-c patient-title">
          <div class="required">*</div>
          <div>{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? '证件号' : '就诊卡' }}：</div>
        </div>
        <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
          {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
        </div>
        <div v-else>
          <el-input readonly="readonly" v-model="outCardSerialFormat"></el-input>
        </div>
      </div>
      <div class="sn-f-s-c region" v-if="selectedPatient.patientId && outCardSerial">
        <div class="sn-f-s-c patient-title">
          <div>当前可用余额：</div>
        </div>
        <div class="sn-fc-red1 sn-fw-bold">{{ outCardBalance === '--.--' ? outCardBalance : $sn.format.priceFormat(outCardBalance, 2) }}</div>
      </div>
    </div>
    <div class="sn-f-1 recharge-region">
      <opt :option="$sn.getConfig('outRechargeOption')" @sendBack="sendBackOption"></opt>
      <div class="sn-f-b-s operate" v-if="rechargePattern.length > 0">
        <div class="sn-f-s-0 operate-title">支付方式：</div>
        <div class="sn-f-1 sn-f-s-c operate-region">
          <div class="sn-f-c-c sn-pointer pattern" :style="{'--background': item.background}" :key="item.reg" v-for="item in rechargePattern" @click="goRecharge(item.reg);">
            <div class="iconfont" :class="item.icon"></div>
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="sn-prompt" v-if="promptInfo.length > 0">
        <div class="sn-prompt-title">温馨提示</div>
        <div class="sn-f-s-s sn-prompt-caption" :class="item.type === '2' ? 'sn-fc-red1 ' + item.style : item.style" :key="i" v-for="(item, i) in promptInfo">
          <div class="sn-prompt-star">★</div>
          <div v-html="item.info"></div>
        </div>
      </div>
    </div>
    <pay-result v-if="exhibitionPayResult" :params="payResultParams" @sendBack="sendBackPayResult">
      <template v-slot:result>
        <div class="sn-f-col-s-c result-slot">
          <div class="sn-f-s-c result-line">
            <div><span style="letter-spacing: 0.5em;">就诊</span>人：</div>
            <div class="sn-f-1 sn-omit">{{ selectedPatient.patientName }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>
              <template v-if="$sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL">
                <span style="letter-spacing: 0.5em;">证件</span>号：
              </template>
              <template v-else>
                <span style="letter-spacing: 0.5em;">就诊</span>卡：
              </template>
            </div>
            <div class="sn-f-1 sn-omit">{{ outCardSerialFormat }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>{{ payResultParams.label }}单号：</div>
            <div class="sn-f-1 sn-omit">{{ Object.values(payResultParams.pay)[0].serial }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>{{ payResultParams.label }}金额：</div>
            <div class="sn-f-1 sn-omit">{{ payResultParams.cost }}</div>
          </div>
        </div>
      </template>
    </pay-result>
    <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
    <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" @sendBack="sendBackBindCard"></bind-card>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';

export default {
  components: {
    'opt': () => import('@/pages/recharge/opt'),
    'pay-result': () => import('@/components/pay-result'),
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  mixins: [HomepageMixin],
  data() {
    return {
      patientList: [],
      selectedPatient: {},
      outCardSerial: '',
      outCardSerialFormat: '',
      outCardBalance: '--.--',
      rechargeCost: '',
      permitRechargeCost: 0,
      rechargePattern: [],
      promptInfo: [],
      //
      isThroughRechargeTimeVerification: true,
      //
      isRestrictOutCardBalance: false,
      isRestrictRechargeCost: false,
      //
      isVerifyOutCardBalance: false,
      isShowVerifyOutCardBalancePrompt: false,
      //
      isSystemFailed: false,
      //
      isShowOutCardIrregularPrompt: false,
      outCardIrregularPrompt: '',
      //
      isOpenCardManage: self.$sn.getConfig('isOpenCardManage'),
      outRechargeLabel: self.$sn.getConfig('outRechargeLabel'),
      //
      exhibitionCreatePatient: false,
      //
      exhibitionBindCard: false
    };
  },
  watch: {
    selectedPatient: async function(patient) {
      this.outCardSerial = '';
      this.outCardSerialFormat = '';
      this.outCardBalance = '--.--';
      if (patient.patientId) {
        const handle = await Tools.handlePatientInfo(patient);
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) {
            this.outCardSerialFormat = patient.idCardEncrypt;
          }
        }
        if (this.outCardSerial) {
          this.treatOutCard();
        }
        else {
          const compare = {
            [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
          };
          this.$sn.assembly.modal({
            caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
            success: (modal) => {
              if (modal.confirm) {
                this.navigateUrl('addition-card');
              }
            }
          });
        }
      }
    },
    rechargeCost: {
      handler: function(value) {
        this.isRestrictOutCardBalance = false;
        this.isRestrictRechargeCost = false;
        if (this.$sn.getConfig('outCardBalanceRestrict') > 0 && parseFloat(this.outCardBalance) > this.$sn.getConfig('outCardBalanceRestrict')) {
          this.isRestrictOutCardBalance = true;
        }
        else if (!this.verifyRestrictRechargeCost()) {
          this.isRestrictRechargeCost = true;
        }
        if (this.$sn.getConfig('isRechargeVerifyOutCardBalance') && this.isVerifyOutCardBalance && this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SZY) {
          this.isShowVerifyOutCardBalancePrompt = false;
          if (parseFloat(this.outCardBalance) >= this.$sn.getConfig('outCardBalanceRechargeRestrict')) {
            this.permitRechargeCost = 0;
            this.isShowVerifyOutCardBalancePrompt = true;
          }
          else {
            const cost = Math.round((this.$sn.getConfig('outCardBalanceRechargeRestrict') - parseFloat(this.outCardBalance)) * 100) / 100;
            if (parseFloat(value) > cost || parseFloat(value) <= 0) {
              this.permitRechargeCost = cost;
              this.isShowVerifyOutCardBalancePrompt = true;
            }
          }
        }
      },
      immediate: true
    }
  },
  created: function() {
    this.formatRechargePattern();
    this.verifyCurrentTime(new Date(this.$sn.format.date(new Date(), 'yyyy-MM-dd HH:mm') + ':00'));
    this.handlePatientInfo();
    this.getPromptInfo();
  },
  methods: {
    formatRechargePattern() {
      const compare = {
        '1': {
          'title': '支付宝',
          'icon': 'icon-alipay',
          'background': this.$sn.color.alipay
        },
        '2': {
          'title': '微信',
          'icon': 'icon-weixin2',
          'background': this.$sn.color.wechat
        }
      };
      this.$sn.getConfig('pcPayPattern').forEach(el => {
        if (!this.$sn.validate.empty(compare[el])) {
          this.rechargePattern.push({
            reg: el,
            ...compare[el]
          });
        }
      });
    },
    verifyCurrentTime(time) {
      this.isThroughRechargeTimeVerification = true;
      const startMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeEndTime') + ':00';
      const startMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd', 1, 'day') + ' 00:00:00';
      const endMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' 00:00:00';
      const endMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeStartTime') + ':00';
      const standard = this.$sn.format.date(time, 'yyyy-MM-dd HH:mm:ss');
      if ((standard >= startMinDate && standard <= startMaxDate) || (standard >= endMinDate && standard <= endMaxDate)) {
        this.isThroughRechargeTimeVerification = false;
      }
    },
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      if (this.patientList && this.patientList.length > 0) {
        this.selectedPatient = this.$sn.utils.getCurrentPatient();
      }
    },
    treatOutCard() {
      if (this.$sn.getConfig('isRechargeVerifyOutCard')) {
        this.verifyOutCard();
      }
      else {
        this.getOutCardBalance();
      }
    },
    verifyOutCard() {
      const params = {
        url: Swagger.verifyCard,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          cardNo: this.isOpenCardManage ? this.selectedPatient.outCardNo : this.outCardSerial,
          cardType: '1',
          hosId: this.$sn.utils.getHospitalId(),
          patId: this.selectedPatient.patientId,
          payType: '1',
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId()
        })
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        this.isSystemFailed = false;
        this.isShowOutCardIrregularPrompt = false;
        this.outCardIrregularPrompt = '';
        if (result && result.data && this.$sn.validate.json(result.data)) {
          if (JSON.parse(result.data).ResultCode === '0') {
            this.getOutCardBalance();
          }
          else {
            this.outCardIrregularPrompt = JSON.parse(result.data).ResultMsg;
            this.isShowOutCardIrregularPrompt = true;
          }
        }
        else {
          this.isSystemFailed = true;
        }
      });
    },
    getOutCardBalance() {
      const params = {
        url: Swagger.getCardBalance,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          bindType: this.$sn.utils.getPlatformType(),
          cardNo: this.isOpenCardManage ? this.selectedPatient.outCardNo : this.outCardSerial,
          clinicType: '1',
          hosArea: '',
          hosId: this.$sn.utils.getHospitalId(),
          idCardNo: '',
          openId: this.$sn.utils.getOpenId(),
          patName: '',
          patientId: this.selectedPatient.patientId,
          reservedDate: '',
          state: ''
        })
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        this.outCardBalance = '--.--';
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              this.outCardBalance = result.data.cardBalance;
              this.isRestrictOutCardBalance = false;
              this.isRestrictRechargeCost = false;
              if (this.$sn.getConfig('outCardBalanceRestrict') > 0 && parseFloat(this.outCardBalance) > this.$sn.getConfig('outCardBalanceRestrict')) {
                this.isRestrictOutCardBalance = true;
              }
              else if (!this.verifyRestrictRechargeCost()) {
                this.isRestrictRechargeCost = true;
              }
              this.isVerifyOutCardBalance = false;
              this.isShowVerifyOutCardBalancePrompt = false;
              if (this.$sn.getConfig('isRechargeVerifyOutCardBalance')) {
                if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SZY) {
                  if (result.data.operateState === '0') {
                    this.isVerifyOutCardBalance = true;
                    if (parseFloat(this.outCardBalance) >= this.$sn.getConfig('outCardBalanceRechargeRestrict')) {
                      this.permitRechargeCost = 0;
                      this.isShowVerifyOutCardBalancePrompt = true;
                    }
                    else {
                      const cost = Math.round((this.$sn.getConfig('outCardBalanceRechargeRestrict') - parseFloat(this.outCardBalance)) * 100) / 100;
                      if (parseFloat(this.rechargeCost) > cost || parseFloat(this.rechargeCost) <= 0) {
                        this.permitRechargeCost = cost;
                        this.isShowVerifyOutCardBalancePrompt = true;
                      }
                    }
                  }
                }
                else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_YTS || this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_JNRM) {
                  if (result.data.operateState === '0') {
                    this.isVerifyOutCardBalance = true;
                  }
                }
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: Messages.RECHARGE010,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages.RECHARGE010,
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001,
            isCancel: false
          });
        }
      });
    },
    getPromptInfo() {
      const params = {
        domain: 'static',
        url: '/hos/ui/caption/recharge/prompt.js?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')
      };
      this.$sn.utils.ordinaryRequest(params).then(result => {
        if (result && result.out && result.out.recharge && result.out.recharge[this.$sn.utils.getHospitalId()] && result.out.recharge[this.$sn.utils.getHospitalId()].length > 0) {
          this.promptInfo = result.out.recharge[this.$sn.utils.getHospitalId()];
        }
      });
    },
    verifyRestrictRechargeCost() {
      if (this.$sn.validate.empty(this.rechargeCost)) {
        return true;
      }
      if (this.$sn.getConfig('maxOutRecharge') === 0) {
        return this.$sn.getConfig('minOutRecharge') <= parseFloat(this.rechargeCost);
      }
      else {
        return this.$sn.getConfig('minOutRecharge') <= parseFloat(this.rechargeCost) && parseFloat(this.rechargeCost) <= this.$sn.getConfig('maxOutRecharge');
      }
    },
    verifyPermitRecharge() {
      if (!this.selectedPatient || !this.selectedPatient.patientId) {
        this.$sn.assembly.modal({
          caption: Messages.PATIENT001,
          success: (modal) => {
            if (modal.confirm) {
              this.navigateUrl('addition-patient');
            }
          }
        });
        return false;
      }
      if (!this.outCardSerial) {
        this.$sn.assembly.modal({
          caption: Messages.PATIENT043,
          success: (modal) => {
            if (modal.confirm) {
              this.navigateUrl('addition-card');
            }
          }
        });
        return false;
      }
      if (this.outCardBalance === '--.--') {
        this.$sn.assembly.modal({
          caption: '系统暂时无法使用您当前的卡，请稍候重试。',
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (!this.rechargeCost || parseFloat(this.rechargeCost) <= 0 || !this.$sn.validate.amount(this.rechargeCost)) {
        this.$sn.assembly.modal({
          caption: Messages.RECHARGE008,
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (parseFloat(this.rechargeCost) < this.$sn.getConfig('minOutRecharge')) {
        this.$sn.assembly.modal({
          caption: this.$sn.format.caption(Messages.RECHARGE007, [this.$sn.getConfig('minOutRecharge')]),
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.$sn.getConfig('maxOutRecharge') > 0 && parseFloat(this.rechargeCost) > this.$sn.getConfig('maxOutRecharge')) {
        this.$sn.assembly.modal({
          caption: this.$sn.format.caption(Messages.RECHARGE006, [this.$sn.getConfig('maxOutRecharge')]),
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (!this.isThroughRechargeTimeVerification) {
        this.$sn.assembly.modal({
          caption: this.outRechargeLabel + '时间为每天' + this.$sn.getConfig('rechargeStartTime') + '-' + this.$sn.getConfig('rechargeEndTime') + '。',
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.isRestrictOutCardBalance) {
        this.$sn.assembly.modal({
          caption: '您当前余额大于' + this.$sn.getConfig('outCardBalanceRestrict') + '，请结合缴费情况' + this.outRechargeLabel + '。',
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.isRestrictRechargeCost) {
        let caption = '单笔' + this.outRechargeLabel + '金额不能';
        if (this.$sn.getConfig('maxOutRecharge') > 0) caption += '大于' + this.$sn.getConfig('maxOutRecharge') + '元或者';
        caption += '小于' + this.$sn.getConfig('minOutRecharge') + '元！';
        this.$sn.assembly.modal({
          caption: caption,
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.isShowVerifyOutCardBalancePrompt) {
        const compare = {
          [this.perpetual.HOSPITAL_ID_SZY]: '社保卡最大' + this.outRechargeLabel + '金额为1500元，当前可' + this.outRechargeLabel + '金额为' + this.permitRechargeCost + '。',
          [this.perpetual.HOSPITAL_ID_YTS]: '该卡已停用或已挂失，暂时无法使用',
          [this.perpetual.HOSPITAL_ID_JNRM]: '暂不支持扶贫患者线上' + this.outRechargeLabel + '！'
        };
        this.$sn.assembly.modal({
          caption: compare[this.$sn.utils.getHospitalId()],
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.isSystemFailed) {
        this.$sn.assembly.modal({
          caption: Messages.C001,
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.isShowOutCardIrregularPrompt) {
        this.$sn.assembly.modal({
          caption: this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL ? '未查询到门诊卡信息。' : this.outCardIrregularPrompt,
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      return true;
    },
    formatRechargeCost(value) {
      value = value.toString();
      const standard = value.split('.');
      if ((standard[1] || '').length < 2) {
        standard[1] = standard[1] || '';
        standard[1] += new Array(2 - standard[1].length + 1).join('0');
      }
      return standard.join('.');
    },
    async goRecharge(reg) {
      const exhibition = (serial, qr) => {
        this.payResultParams = {
          func: this.perpetual.FUNCTION_ID_MZCZ,
          title: '请您扫码进行' + this.outRechargeLabel,
          sub: '',
          label: this.outRechargeLabel,
          cost: this.rechargeCost,
          pay: {
            [reg]: {
              serial: serial,
              qr: qr
            }
          },
          interaction: {
            text: '前往' + this.outRechargeLabel + '记录',
            disabled: true,
            func: () => {
              this.navigateUrl('/recharge/out/homepage/record');
            }
          }
        };
        this.exhibitionPayResult = true;
      };
      if (this.verifyPermitRecharge()) {
        this.verifyCurrentTime(new Date());
        if (this.isThroughRechargeTimeVerification) {
          this.rechargeCost = this.formatRechargeCost(this.rechargeCost);
          let primary = reg;
          const ExtendInfo = {};
          let ip = '';
          if (this.$sn.utils.getSubRegType(reg)) {
            this.$set(ExtendInfo, 'subPayType', this.$sn.utils.getSubRegType(reg));
            if (this.$sn.utils.isYuanQi()) {
              this.$set(ExtendInfo, 'patId', this.selectedPatient.outCardId);
              this.$set(ExtendInfo, 'patName', this.selectedPatient.patientName);
              if (this.$sn.utils.getRegType() === this.perpetual.REG_TYPE_YUANQI2) {
                ip = await Tools.getIp();
              }
            }
            this.$set(ExtendInfo, 'busType', this.perpetual.PAY_BUSINESS_TYPE_OUT_RECHARGE);
            primary = this.$sn.utils.getRegType();
            console.log(ip);
          }
          let Subject = '就诊卡' + this.outRechargeLabel;
          if (!this.$sn.validate.empty(this.$sn.getConfig('outRechargeSubjectLabel'))) {
            const label = [];
            this.$sn.getConfig('outRechargeSubjectLabel')[1].split(',').forEach(el => {
              if (!this.$sn.validate.empty(this.$sn.format.getQuality(this, el))) {
                label.push(this.$sn.format.getQuality(this, el));
              }
            });
            if (label.length > 0) Subject = this.$sn.format.caption(this.$sn.getConfig('outRechargeSubjectLabel')[0], label);
          }
          if (this.$sn.getConfig('pcUpdateRecharge')) {
            this.$sn.assembly.loading(true);
            this.$sn.utils.ordinaryRequest({
              url: Swagger.pcUpdateRechargeScanQR,
              method: 'POST',
              header: true,
              data: JSON.stringify({
                appId: this.$sn.utils.getHospitalId(),
                cardNo: this.outCardSerial,
                cardType: this.perpetual.OUT_CARD_CLINIC_TYPE,
                dataType: this.$sn.utils.getPlatformType(),
                extendInfo: this.$sn.validate.empty(ExtendInfo) ? '' : JSON.stringify(ExtendInfo),
                extendType: '',
                himServiceId: '',
                himServiceType: '',
                limitPay: this.$sn.getConfig('isRestrictCreditCardOutRecharge') ? '' : '0',
                openid: this.$sn.utils.getOpenId(),
                outTradeNo: '',
                pagePath: '',
                payAccountNo: this.$sn.getConfig('outRechargeMerchantSerial'),
                payType: primary,
                phoneNumber: this.selectedPatient.patientPhone,
                projectType: this.$sn.utils.getProjectType(),
                remark: '备注',
                serviceType: this.perpetual.SERVICE_TYPE_RECHARGE,
                subject: Subject,
                totalFee: this.rechargeCost,
                userId: this.selectedPatient.patientId,
                userName: this.selectedPatient.patientName
              })
            }).then(result => {
              this.$sn.assembly.loading(false);
              if (result) {
                if (result.code === 0) {
                  if (!this.$sn.validate.empty(result.data) && !this.$sn.validate.empty(result.data.outTradeNo) && !this.$sn.validate.empty(result.data.Data)) {
                    this.$sn.assembly.loading(true);
                    this.$sn.utils.ordinaryRequest({
                      url: Swagger.storePaymentParameter,
                      method: 'POST',
                      data: JSON.stringify({
                        accountId: this.$sn.utils.getAccountId(),
                        cardNo: this.outCardSerial,
                        cardType: this.perpetual.OUT_CARD_CLINIC_TYPE,
                        dataType: this.$sn.utils.getPlatformType(),
                        deptId: '',
                        deptName: '',
                        doctorId: '',
                        doctorName: '',
                        extendInfo: this.$sn.validate.empty(ExtendInfo) ? '' : JSON.stringify(ExtendInfo),
                        extendType: '',
                        himServiceId: '',
                        himServiceType: '',
                        hosId: this.$sn.utils.getHospitalId(),
                        noticeType: this.perpetual.NOTICE_TYPE_OUT_RECHARGE,
                        outTradeNo: result.data.outTradeNo,
                        patientId: this.selectedPatient.patientId,
                        patientIdCard: this.selectedPatient.patientIdCardNo,
                        patientName: this.selectedPatient.patientName,
                        patientPhone: this.selectedPatient.patientPhone,
                        payAccountNo: this.$sn.getConfig('outRechargeMerchantSerial'),
                        payType: primary,
                        platformId: this.$sn.utils.getPlatformType(),
                        platformUserId: this.$sn.utils.getOpenId(),
                        projectType: this.$sn.utils.getProjectType(),
                        remark: '',
                        totalFee: this.rechargeCost
                      }),
                      reload: false
                    }).then(res => {
                      this.$sn.assembly.loading(false);
                      if (res && res.code === 0 && res.data && res.data.ResultCode && (res.data.ResultCode === 0 || res.data.ResultCode === '0')) {
                        exhibition(result.data.outTradeNo, result.data.Data);
                      }
                      else {
                        this.$sn.assembly.modal({
                          caption: Messages.RECHARGE002,
                          isCancel: false
                        });
                      }
                    });
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: this.$sn.validate.empty(result.data.outTradeNo) || this.$sn.validate.empty(result.data.Data) ? Messages.RECHARGE003 : Messages.C002,
                      isCancel: false
                    });
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.msg,
                    isCancel: false
                  });
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.C001,
                  isCancel: false
                });
              }
            });
          }
          else {
            this.$sn.assembly.loading(true);
            this.$sn.utils.ordinaryRequest({
              url: Swagger.pcRechargeScanQR,
              method: 'POST',
              header: true,
              data: JSON.stringify({
                body: Subject,
                cardTypeCode: this.perpetual.OUT_CARD_CLINIC_TYPE,
                expand: '',
                hosId: this.$sn.utils.getHospitalId(),
                ip: '',
                patientCard: this.outCardSerial,
                patientCardId: this.selectedPatient.patientIdCardNo,
                patientId: this.selectedPatient.patientId,
                patientName: this.selectedPatient.patientName,
                patientPhone: this.selectedPatient.patientPhone,
                payType: primary,
                platformId: 'PCNYXH000S',
                serviceType: this.perpetual.SERVICE_TYPE_RECHARGE,
                terminalId: 'PCNYXH000S',
                totalFee: this.rechargeCost
              }),
              reload: false
            }).then(result => {
              this.$sn.assembly.loading(false);
              if (result) {
                if (result.code === 0) {
                  if (result.data && this.$sn.validate.json(result.data)) {
                    const res = JSON.parse(result.data);
                    if (res.ResultCode === '0' && res.outTradeNo && res.Data) {
                      exhibition(res.outTradeNo, res.Data);
                    }
                    else {
                      this.$sn.assembly.modal({
                        caption: Messages.RECHARGE003,
                        isCancel: false
                      });
                    }
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: Messages.RECHARGE003,
                      isCancel: false
                    });
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.msg,
                    isCancel: false
                  });
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.C001,
                  isCancel: false
                });
              }
            });
          }
        }
      }
    },
    sendBackPatient(id) {
      if (id) {
        this.selectedPatient = this.patientList.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    sendBackOption(item) {
      this.rechargeCost = item;
    },
    sendBackPayResult(type) {
      this.getOutCardBalance();
      this.homepage_mixin_sendBackPayResult(type);
    },
    sendBackCreatePatient(type) {
      if (type) {
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionCreatePatient = false;
    },
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'addition-patient') {
        this.exhibitionCreatePatient = true;
      }
      else if (url === 'addition-card') {
        this.exhibitionBindCard = true;
      }
      else this.homepage_mixin_navigateUrl(url, item, params, type);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/pages/recharge/recharge";
</style>
